import { Head, Link } from "@inertiajs/react"
import { PageLayout } from "@/components/VocationalTest/PageLayout"
import { Card } from "@/components/ui/card"
import { Button } from "@/components/ui/button"
import { CheckCircle, ArrowRight } from "lucide-react"

// TODO: Futuramente esta página receberá props com os produtos adquiridos
// e mostrará links específicos para cada um:
// - Teste Avançado → /advanced-welcome
// - Mentoria → página para agendar
// - Livro/Audiobook → página de download/acesso
// Por enquanto, versão simplificada focada no teste avançado.

export default function CheckoutSuccess() {
  return (
    <>
      <Head title="Pagamento Confirmado" />
      <PageLayout>
        <div className="w-full max-w-md">
          <Card className="w-full p-8 md:p-12 shadow-elegant text-center">
            <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-success/10 mb-6">
              <CheckCircle className="w-8 h-8 text-success" />
            </div>

            <h1 className="text-2xl font-bold mb-3">Pagamento Confirmado!</h1>

            <p className="text-muted-foreground mb-2">
              Obrigado pela sua compra. Seu acesso foi liberado.
            </p>

            <p className="text-sm text-muted-foreground mb-8">
              Você receberá um email com os detalhes da compra.
            </p>

            <div className="space-y-3">
              <Button asChild className="w-full bg-gradient-primary">
                <Link href="/advanced-welcome">
                  Iniciar Teste Avançado
                  <ArrowRight className="w-4 h-4 ml-2" />
                </Link>
              </Button>

              <Button asChild variant="outline" className="w-full">
                <Link href="/results">
                  Ver meu resultado completo
                </Link>
              </Button>
            </div>

            <p className="text-xs text-muted-foreground mt-6">
              Em caso de dúvidas, entre em contato pelo email de suporte.
            </p>
          </Card>
        </div>
      </PageLayout>
    </>
  )
}
